// Copyright (c) Bentley Systems
export class DocumentVersion {
  public id: number;
  public versionCount: number;
  public originalFileName: string;

  constructor(id: number, versionCount: number, originalFileName: string) {
    this.id = id;
    this.versionCount = versionCount;
    this.originalFileName = originalFileName;
  }
}
